import { Box } from '@mui/material';

import { Alignments } from '../../../../shared/components/ui/Table/enums/alignments.enum';
import { TableColumnDef } from '../../../../shared/components/ui/Table/models/table-column.model';
import { castTo } from '../../../../shared/utils/cast-to';
import { WebGameResponseModel } from '../../../models/web-game-response.model';
import { GameThumbnailAndTitleCell } from '../components/game-thumbnail-and-title-cell';

export const webGamesTableColumns: TableColumnDef[] = [
  {
    field: 'title',
    headerName: 'Title',
    alignment: Alignments.LEFT,
    width: '49%',
    valueGetter: row => {
      return (
        <GameThumbnailAndTitleCell
          row={castTo<WebGameResponseModel>(row)}
        ></GameThumbnailAndTitleCell>
      );
    },
  },
  {
    field: 'genre',
    headerName: 'Genre',
    alignment: Alignments.LEFT,
    width: '15%',
    valueGetter: row => <Box>{castTo<WebGameResponseModel>(row).genre}</Box>,
  },
  {
    field: 'orientation',
    headerName: 'Orientation',
    alignment: Alignments.LEFT,
    width: '15%',
    valueGetter: row => (
      <Box>{castTo<WebGameResponseModel>(row).orientation}</Box>
    ),
  },
  {
    field: 'size',
    headerName: 'Size',
    alignment: Alignments.RIGHT,
    width: '18%',
    valueGetter: row => <Box>{castTo<WebGameResponseModel>(row).size}</Box>,
  },
];
